import {
  GET_ROLESANDPERMISSIONS,
  GET_SUPPLIERROLE,
  FETCH_PARENT_ROLES,
  FETCH_PERMISSIONS_TREE,
  FETCH_ROLE_PERMISSIONS,
  UPDATE_ROLE_PERMISSIONS,
  FETCH_SUB_ROLES,
  FETCH_FILTERED_TREE,
  FETCH_SUB_ROLE_PERMS,
  CREATE_SUB_ROLE,
  UPDATE_SUB_ROLE,
} from "resources/actionTypes";

const initialRolesAndPermissionsState = {
  loading: false,
  error: null,
  rolesAndPermissions: [],
};

const initialSupplierRole = {
  loading:false,
  error:null,
  roles:[],
}

export const getRolesAndPermissions = (
  state = initialRolesAndPermissionsState,
  action
) => {

  switch (action.type) {
    case GET_ROLESANDPERMISSIONS.GET_ROLESANDPERMISSIONS_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_ROLESANDPERMISSIONS.GET_ROLESANDPERMISSIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        rolesAndPermissions: action.rolesAndPermissions,
      };
    case GET_ROLESANDPERMISSIONS.GET_ROLESANDPERMISSIONS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export const getSupplierRole = (
  state = initialSupplierRole,
  action
) => {

  switch (action.type) {
    case GET_SUPPLIERROLE.GET_SUPPLIERROLE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_SUPPLIERROLE.GET_SUPPLIERROLE_SUCCESS:
      return {
        ...state,
        loading: false,
        roles: action.supplierRoles,
      };
    case GET_SUPPLIERROLE.GET_SUPPLIERROLE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

const initialRbacState = {
  parentRoles: [],
  permissionsTree: [],
  assignedPermIds: [],
  subRoles: [],
  filteredTree: [],
  subAssignedPermIds: [],
  loading: false,
  error: null,
};

export const rbacReducer = (state = initialRbacState, action) => {
  switch (action.type) {
    case FETCH_PARENT_ROLES.FETCH_PARENT_ROLES_REQUESTED:
    case FETCH_PERMISSIONS_TREE.FETCH_PERMISSIONS_TREE_REQUESTED:
    case FETCH_ROLE_PERMISSIONS.FETCH_ROLE_PERMISSIONS_REQUESTED:
    case UPDATE_ROLE_PERMISSIONS.UPDATE_ROLE_PERMISSIONS_REQUESTED:
    case FETCH_SUB_ROLES.FETCH_SUB_ROLES_REQUESTED:
    case FETCH_FILTERED_TREE.FETCH_FILTERED_TREE_REQUESTED:
    case FETCH_SUB_ROLE_PERMS.FETCH_SUB_ROLE_PERMS_REQUESTED:
    case CREATE_SUB_ROLE.CREATE_SUB_ROLE_REQUESTED:
    case UPDATE_SUB_ROLE.UPDATE_SUB_ROLE_REQUESTED:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_PARENT_ROLES.FETCH_PARENT_ROLES_SUCCESS:
      return {
        ...state,
        loading: false,
        parentRoles: action.payload || [],
      };

    case FETCH_PERMISSIONS_TREE.FETCH_PERMISSIONS_TREE_SUCCESS:
      return {
        ...state,
        loading: false,
        permissionsTree: action.payload || [],
      };

    case FETCH_ROLE_PERMISSIONS.FETCH_ROLE_PERMISSIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        assignedPermIds: action.payload?.assignedPermissionIds || [],
      };

    case UPDATE_ROLE_PERMISSIONS.UPDATE_ROLE_PERMISSIONS_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case FETCH_SUB_ROLES.FETCH_SUB_ROLES_SUCCESS:
      return {
        ...state,
        loading: false,
        subRoles: action.payload || [],
      };

    case FETCH_FILTERED_TREE.FETCH_FILTERED_TREE_SUCCESS:
      return {
        ...state,
        loading: false,
        filteredTree: action.payload || [],
      };

    case FETCH_SUB_ROLE_PERMS.FETCH_SUB_ROLE_PERMS_SUCCESS:
      return {
        ...state,
        loading: false,
        subAssignedPermIds: action.payload?.assignedPermissionIds || [],
      };

    case CREATE_SUB_ROLE.CREATE_SUB_ROLE_SUCCESS:
    case UPDATE_SUB_ROLE.UPDATE_SUB_ROLE_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case FETCH_PARENT_ROLES.FETCH_PARENT_ROLES_FAILED:
    case FETCH_PERMISSIONS_TREE.FETCH_PERMISSIONS_TREE_FAILED:
    case FETCH_ROLE_PERMISSIONS.FETCH_ROLE_PERMISSIONS_FAILED:
    case UPDATE_ROLE_PERMISSIONS.UPDATE_ROLE_PERMISSIONS_FAILED:
    case FETCH_SUB_ROLES.FETCH_SUB_ROLES_FAILED:
    case FETCH_FILTERED_TREE.FETCH_FILTERED_TREE_FAILED:
    case FETCH_SUB_ROLE_PERMS.FETCH_SUB_ROLE_PERMS_FAILED:
    case CREATE_SUB_ROLE.CREATE_SUB_ROLE_FAILED:
    case UPDATE_SUB_ROLE.UPDATE_SUB_ROLE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
